import { AudioManager } from "@phaser/core/audio/AudioManager";

export function showComboScoreEffect(scene: Phaser.Scene, amount: number) {
  const { width, height } = scene.scale;

  AudioManager.playSfx("sfx-ding");

  const baseX = width / 2;
  const baseY = height * 0.28;

  // 너무 넓게 퍼지면 안 보이니까 범위를 줄임
  const offsetX = Phaser.Math.Between(-300, 300);
  const offsetY = Phaser.Math.Between(-40, 40);

  const x = baseX + offsetX;
  const y = baseY + offsetY;

  const finalScale = Phaser.Math.Clamp(1.0 + amount / 120, 1, 1.9);

  // 메인 텍스트
  const text = scene.add
    .text(x, y, `+${amount}`, {
      fontFamily: "Luckiest Guy",
      fontSize: "100px",
      color: "#FFD93D",
      stroke: "#1C120E",
      strokeThickness: 16,
    })
    .setOrigin(0.5)
    .setDepth(200)
    .setAlpha(1)
    .setScale(0.2);

  // 등장 "팡" 연출
  scene.tweens.add({
    targets: text,
    scale: finalScale * 1.15,
    duration: 200,
    ease: "Quad.Out",
    onComplete: () => {
      scene.tweens.add({
        targets: text,
        scale: finalScale,
        duration: 160,
        ease: "Quad.Out",
      });
    },
  });

  // 잠깐 유지 후 떠오르며 사라짐
  scene.tweens.add({
    targets: text,
    y: y - 40,
    alpha: 0,
    delay: 300,
    duration: 300,
    ease: "Cubic.Out",
    onComplete: () => {
      text.destroy();
    },
  });
}

export function playGameOverTextEffect(
  scene: Phaser.Scene,
  onComplete: () => void,
) {
  const { width, height } = scene.scale;
  const finalY = height / 2;

  AudioManager.playSfx("sfx-game-over");

  const gameOverText = scene.add
    .image(width / 2, 0, "gameover-text")
    .setOrigin(0.5)
    .setDepth(9999);

  scene.tweens.add({
    targets: gameOverText,
    y: finalY + 45,
    duration: 320,
    ease: "Cubic.easeIn",
    onComplete: () => {
      gameOverText.setScale(1.12, 0.85);

      scene.tweens.add({
        targets: gameOverText,
        y: finalY - 25,
        duration: 160,
        ease: "Quad.easeOut",
        onComplete: () => {
          scene.tweens.add({
            targets: gameOverText,
            y: finalY,
            scaleX: 1,
            scaleY: 1,
            duration: 140,
            ease: "Quad.easeIn",
          });
        },
      });
    },
  });

  scene.time.delayedCall(3500, () => {
    gameOverText.destroy();
    onComplete?.();
  });
}
export function createMonsterPortalEffect(scene: Phaser.Scene) {
  const { width, height } = scene.scale;

  const centerX = width / 2;
  const centerY = (height * 505) / 1366;

  // 가운데 회전 스핀
  const spin = scene.add
    .image(centerX, centerY + 8, "monster-portal-spin")
    .setOrigin(0.5)
    .setScale(0.4);

  // 바깥 포탈
  const portal = scene.add
    .image(centerX, centerY, "monster-portal")
    .setOrigin(0.5)
    .setScale(0.4);

  // 무한 회전
  scene.tweens.add({
    targets: spin,
    angle: 360,
    duration: 1000,
    repeat: -1,
    ease: "Linear",
  });

  return {
    portal,
    spin,
  };
}

export function createstageCrackEffect(scene: Phaser.Scene) {
  const { width, height } = scene.scale;

  // 포탈애니메이션 한번만 호출
  if (!scene.anims.exists("stage-crack")) {
    scene.anims.create({
      key: "stage-crack",
      frames: scene.anims.generateFrameNumbers("stage-crack-anim", {
        start: 0,
        end: 3, // 프레임 수
      }),
      frameRate: 10,
      repeat: -1, // 무한 반복
    });
  }

  // 포탈 이미지
  const crack = scene.add.sprite(width / 2, height / 2, "stage-crack-anim");

  crack.setOrigin(0.5);
  crack.play("stage-crack");

  return crack;
}

export function createComboText(scene: Phaser.Scene) {
  const { width, height } = scene.scale;

  return scene.add
    .text(width / 2, height * 0.26, "", {
      fontFamily: "Luckiest Guy",
      fontSize: "60px",
      color: "#FFD93D",
      stroke: "#1C120E",
      strokeThickness: 12,
    })
    .setOrigin(0.5)
    .setVisible(false);
}

export function updateComboText(
  scene: Phaser.Scene,
  comboText: Phaser.GameObjects.Text,
  combo: number,
) {
  scene.tweens.killTweensOf(comboText);

  // 콤보 끊김
  if (combo < 10) {
    if (!comboText.visible) return;

    scene.tweens.add({
      targets: comboText,
      x: comboText.x,
      y: comboText.y + 25,
      alpha: 0,
      duration: 220,
      ease: "Quad.In",
      yoyo: false,
      onUpdate: () => {
        comboText.x += Phaser.Math.Between(-10, 10);
      },
      onComplete: () => {
        comboText.setVisible(false).setAlpha(1).setAngle(0);

        // 원위치 복구
        const { width, height } = scene.scale;

        comboText.setPosition(width / 2, height * 0.26);
      },
    });

    return;
  }

  comboText.setText(`${combo} COMBO`).setVisible(true).setAlpha(1);
  comboText.setScale(0.96);

  scene.tweens.add({
    targets: comboText,
    scaleX: 1.1,
    scaleY: 1.1,
    duration: 120,
    ease: "Quad.Out",
    yoyo: true,
  });
}
